var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Transition", { attrs: { name: "modal" } }, [
    _vm.show
      ? _c("div", { staticClass: "modal-mask" }, [
          _c("div", { staticClass: "modal-wrapper" }, [
            _c(
              "div",
              { ref: "modalContainer", staticClass: "modal-container" },
              [
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-header" },
                  [_vm._t("header", [_vm._v("default header")])],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _vm._t("body", [
                      _c("label", { attrs: { for: "check_off_type" } }, [
                        _vm._v("Check off type")
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.checkOffType,
                              expression: "checkOffType"
                            }
                          ],
                          staticClass: "fixed-height",
                          attrs: { name: "check_off_type" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.checkOffType = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        [
                          _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Please select one")
                          ]),
                          _vm._v(" "),
                          _c(
                            "option",
                            { attrs: { value: "skills_assessment" } },
                            [_vm._v("Skills assessment")]
                          ),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "onboarding" } }, [
                            _vm._v("Onboarding")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "start" } }, [
                            _vm._v("Starting")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "check_off_date" } }, [
                        _vm._v("Check off date")
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.checkOffDate,
                            expression: "checkOffDate"
                          }
                        ],
                        staticClass: "fixed-height",
                        attrs: { type: "date", name: "check_off_date" },
                        domProps: { value: _vm.checkOffDate },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.checkOffDate = $event.target.value
                          }
                        }
                      })
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "modal-footer" },
                  [
                    _vm._t("footer", [
                      _vm.checkOffType && _vm.checkOffDate
                        ? _c("div", [
                            _vm._v(
                              "\n                Showing " +
                                _vm._s(_vm.checkOffType) +
                                " check-off for " +
                                _vm._s(_vm.checkOffDate) +
                                ".\n              "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass:
                            "button apply-filter no-margin no-underline",
                          attrs: {
                            href:
                              "/recruiter/active-requisitions/check-off/" +
                              _vm.checkOffType +
                              "/" +
                              _vm.requisitionId +
                              "/" +
                              _vm.checkOffDate
                          }
                        },
                        [_vm._v("\n              Submit\n            ")]
                      )
                    ])
                  ],
                  2
                )
              ]
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f82f626", { render: render, staticRenderFns: staticRenderFns })
  }
}